import http from '~/common/http'
export default {
    getOrderQueueList(params) {
        return http.get('/api/import-queue/order-queue', {
            params: params
        });
    },

    orderQueueReset(ids) {
        return http.put("/api/import-queue/order-queue-reset", {ids: ids});
    },

    orderQueueManual(ids) {
        return http.put("/api/import-queue/order-queue-manual", {ids: ids});
    },
}


// WEBPACK FOOTER //
// ./src/services/ImportQueue.js